import * as types from 'modules/devices/actionTypes';
import type { SetUpdateModalVisibilityAction } from 'modules/devices/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState = false;

const setVisibility = (_: boolean, { payload: visible }: SetUpdateModalVisibilityAction) => Boolean(visible);

const reset = () => initialState;

export default createReducer<boolean>(initialState, {
  [LOCATION_CHANGE]: reset,
  [types.PATCH_DEVICE_SUCCESS]: reset,
  [types.SET_UPDATE_MODAL_VISIBILITY]: setVisibility,
});
